/**
 * Comment Reply
 *
 * Comment reply titles need a little help.
 * The default comment-reply.js that we enqueue so that
 * the reply form is below each comment only moves the form,
 * adds the cancel reply link, and a hidden input with the
 * comment_post_ID being replied to. It does not change the
 * title.
 *
 * @package DGD Platinum
 * @since   1.0.0
 */

// Define our comment reply funciton.
const dgdCommentReplyTitle = () => {
	const title = document.querySelector('#reply-title');

	if (title) {
		const originalTitle = title.firstChild.nodeValue;
		const replies = document.querySelectorAll('.comment__reply');

		replies.forEach((reply) => {
			reply.onclick = () => {
				const link = reply.querySelector('.comment-reply-link');
				const cancelReply = title.querySelectorAll('small')[0];

				title.firstChild.nodeValue = link.getAttribute('aria-label');

				cancelReply.onclick = () => {
					title.firstChild.nodeValue = originalTitle;
				};
			};
		});
	}
};

document.addEventListener('DOMContentLoaded', dgdCommentReplyTitle);
